export default __webpack_public_path__ + "59b7ad6c7dd8d84142ba3aab0e46c968.png";